module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kj-join_list"
  }, [_c('div', {
    staticClass: "kj-join_list-head"
  }, [_c('span', {
    staticClass: "kj-join_list-title"
  }, [_vm._v("帮砍榜单")]), _vm._v(" "), _c('button', {
    staticClass: "kj-join_list-btn",
    on: {
      "click": _vm.showChange
    }
  }, [_vm._v("活动说明")])]), _vm._v(" "), (!_vm.participatorList.length) ? _c('Nodata') : _c('yd-infinitescroll', {
    ref: "infinitescrollDemo",
    attrs: {
      "on-infinite": _vm.loadList
    }
  }, [_c('div', {
    staticClass: "kj-join_list-items",
    slot: "list"
  }, _vm._l((_vm.participatorList), function(item, index) {
    return _c('div', {
      key: item.nickname,
      staticClass: "kj-join_list-item"
    }, [_c('div', {
      staticClass: "kj-join_list-item_avator"
    }, [(item.img) ? _c('img', {
      attrs: {
        "src": item.img
      }
    }) : _c('img', {
      attrs: {
        "src": require("./noavatar.png")
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "kj-join_list-item_cont"
    }, [_c('div', {
      staticClass: "kj-join_list-item_name"
    }, [_vm._v(_vm._s(item.nickname))]), _vm._v(" "), _c('div', {
      staticClass: "kj-join_list-item_time"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.time)))])]), _vm._v(" "), _c('div', {
      staticClass: "kj-join_list-item_price"
    }, [_vm._v("-￥" + _vm._s((item.bargain_amount / 100).toFixed(2)))])])
  })), _vm._v(" "), _c('span', {
    slot: "doneTip"
  }, [_vm._v("啦啦啦，啦啦啦，没有数据啦~~")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./loading.svg")
    },
    slot: "loadingTip"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f0f07cc","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/participatorList/index.vue
// module id = 292
// module chunks = 0